import { COMPANIES_LIST } from "../../../actions/types";
const initialState = {
  items: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case COMPANIES_LIST:
      return {
        ...state,
        items: action.payload
      };

    default:
      return state;
  }
}
